<template>
  <v-layout
    v-if="getWhiteLabel"
    wrap
  >
    <v-flex
      md5
      xs12
    >
      <v-card
        height="100%"
        class="d-flex align-center justify-center"
      >
        <aum-pie :whitelabel-uuid="whitelabel_uuid" />
      </v-card>
    </v-flex>
    <v-flex
      md7
      xs12
    >
      <overview :whitelabel-stats="whiteLabelStats" />
    </v-flex>
    <v-flex
      xs12
    >
      <v-card height="100%">
        <v-card-title>
          {{ $t('projects.strategyStats') }}
        </v-card-title>
        <v-card-text class="mt-6 mb-6">
          <strategy-stats
            :whitelabel-uuid="whitelabel_uuid"
          />
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex
      xs12
    >
      <v-card height="100%">
        <stats-table
          :whitelabel-stats="whiteLabelStats"
        />
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

import Overview from "@/views/Modules/SpotFutures/Dashboard/partial/Overview.vue";
import StatsTable from "@/views/Modules/SpotFutures/Dashboard/partial/StatsTable.vue";
import AumPie from "@/views/Modules/SpotFutures/Dashboard/partial/AumPie.vue";
import StrategyStats from "@/views/Modules/SpotFutures/Dashboard/partial/StrategyStats.vue";
import  WL_STATS_QUERY from '@/graphql/queries/WhiteLabelStats.gql';

export default {
  name: "SpotFuturesDashboard",
  components: {
    Overview,
    StatsTable,
    AumPie,
    StrategyStats
  },
  data: () => ({
    tab: 0,
    tooltip: null,
    loading: false,
    countAccs: 0,
    countProjects: 0,
    accAuMFound: false,
    countedAccs: 0,
    whitelabel_uuid: null,
  }),
  computed: {
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
  },
  watch: {
    getWhiteLabel(){
       this.reload()
    }
  },
  mounted() {
    if (this.getWhiteLabel) {
      this.whitelabel_uuid = this.getWhiteLabel.uuid
    }
  },
  methods: {
    reload() {
      if (this.getWhiteLabel) {
        this.whitelabel_uuid = this.getWhiteLabel.uuid
        this.$apollo.queries.whiteLabelStats.refetch()
      }
    },
  },
  apollo: {
    whiteLabelStats: {
      query: WL_STATS_QUERY,
      variables() {
        return {
          uuid: this.whitelabel_uuid
        }
      },
      skip() {
        return this.whitelabel_uuid == null
      }
    }
  }
}
</script>

